/**
 * page_view / page_leave collector'i.
 * Aktif sure (engaged time), maksimum scroll yuzdesi ve cikis nedeni page_leave ile gonderilir.
 * SPA'larda history API'si sarmalanarak sayfa gecisleri yakalanir.
 */
import { AUTO_EVENTS } from "../events";

const ENGAGE_TICK_MS = 1000;
const IDLE_THRESHOLD_MS = 30000;

class PageViewCollector {
    constructor(tracker) {
        this.tracker = tracker;
        this.startedAt = 0;
        this.engagedMs = 0;
        this.maxScroll = 0;
        this.lastInteractionAt = 0;
        this.currentPath = "";
        this.tickId = null;
        this.leaveSent = false;
    }

    start() {
        const self = this;

        this.bindScroll();
        this.bindInteraction();
        this.bindHistory();

        document.addEventListener("visibilitychange", function () {
            if (document.visibilityState === "hidden") {
                self.sendLeave("hidden");
            } else {
                // Sekmeye geri donuldu: yeni bir olcum penceresi baslar
                self.resetMetrics();
            }
        });
        window.addEventListener("pagehide", function () {
            self.sendLeave("close");
        });

        this.tickId = setInterval(function () {
            if (document.visibilityState !== "visible") return;
            if (Date.now() - self.lastInteractionAt > IDLE_THRESHOLD_MS) return;
            self.engagedMs += ENGAGE_TICK_MS;
        }, ENGAGE_TICK_MS);

        this.sendView(true);
    }

    bindScroll() {
        const self = this;
        const handler = function () {
            const doc = document.documentElement;
            const body = document.body;
            const scrollTop = window.pageYOffset || doc.scrollTop || 0;
            const viewport = window.innerHeight || doc.clientHeight || 0;
            const total = Math.max(
                doc.scrollHeight || 0,
                body ? body.scrollHeight || 0 : 0,
                doc.offsetHeight || 0,
                viewport
            );
            if (total <= viewport) {
                self.maxScroll = 100;
                return;
            }
            const percent = Math.round(((scrollTop + viewport) / total) * 100);
            if (percent > self.maxScroll) self.maxScroll = Math.min(percent, 100);
        };
        window.addEventListener("scroll", handler, { passive: true });
        handler();
    }

    bindInteraction() {
        const self = this;
        const touch = function () {
            self.lastInteractionAt = Date.now();
        };
        const events = ["mousemove", "mousedown", "keydown", "scroll", "touchstart", "wheel"];
        for (let i = 0; i < events.length; i++) {
            window.addEventListener(events[i], touch, { passive: true });
        }
        touch();
    }

    /** SPA gecisleri: pushState/replaceState sarmalanir, popstate dinlenir. */
    bindHistory() {
        const self = this;
        const wrap = function (method) {
            const original = history[method];
            if (typeof original !== "function") return;
            history[method] = function () {
                const result = original.apply(this, arguments);
                self.onRouteChange();
                return result;
            };
        };
        wrap("pushState");
        wrap("replaceState");
        window.addEventListener("popstate", function () {
            self.onRouteChange();
        });
        window.addEventListener("hashchange", function () {
            self.onRouteChange();
        });
    }

    onRouteChange() {
        const self = this;
        // Router'lar URL'i DOM guncellemesinden once degistirir; title'in oturmasini bekliyoruz.
        setTimeout(function () {
            const path = window.location.pathname + window.location.search;
            if (path === self.currentPath) return;
            self.sendLeave("navigate");
            self.resetMetrics();
            self.sendView(false);
        }, 60);
    }

    resetMetrics() {
        this.startedAt = Date.now();
        this.engagedMs = 0;
        this.maxScroll = 0;
        this.lastInteractionAt = Date.now();
        this.leaveSent = false;
    }

    sendView(isInitial) {
        this.currentPath = window.location.pathname + window.location.search;
        this.resetMetrics();
        this.tracker.emit(AUTO_EVENTS.PAGE_VIEW, {
            is_initial: !!isInitial,
        });
        // SPA gecisinde arama parametresi degismis olabilir
        if (!isInitial) this.tracker.onPageChanged();
    }

    sendLeave(reason) {
        if (this.leaveSent || !this.startedAt) return;
        this.leaveSent = true;
        const duration = Math.round((Date.now() - this.startedAt) / 1000);
        this.tracker.emit(
            AUTO_EVENTS.PAGE_LEAVE,
            {
                exit_reason: reason,
            },
            {
                duration: duration,
                engagedTime: Math.round(this.engagedMs / 1000),
                scrollDepth: this.maxScroll,
                exitReason: reason,
            }
        );
        // page_leave sayfa kapanirken uretilebilir; kuyrugu hemen bosaltiyoruz.
        this.tracker.flush("page_leave");
    }

    stop() {
        if (this.tickId) {
            clearInterval(this.tickId);
            this.tickId = null;
        }
    }
}

export default PageViewCollector;



//////////////////
// WEBPACK FOOTER
// ./static/src/tracker/collectors/pageView.js
// module id = null
// module chunks = 